<div class="loader-overlay-container" *ngIf="(loader.isLoading$ | async)">
    <storybook-awesome-loader [label]="'Loading...'"></storybook-awesome-loader>
</div>
